export const definePage = (page) => {
	return {
		type: 'SET_PAGE',
		page: page,
	};
};
